const modalModule = (store) => {
  store.registerModule('modal', {
    namespaced: true,
    state: {
      open: false,
      fullscreen: false,
      component: null,
      componentProps: null,
      dialogProps: null,
    },
    getters: {
      isOpen: (state) => state.open,
      isFullscreen: (state) => state.fullscreen,
      component: (state) => state.component,
      componentProps: (state) => state.componentProps,
      dialogProps: (state) => state.dialogProps,
    },
    mutations: {
      SET_OPEN: (state, val) => {
        state.open = val;
      },
      SET_FULLSCREEN: (state, val) => {
        state.fullscreen = val;
      },
      SHOW_MODAL: (state, { componentName, componentProps, dialogProps }) => {
        state.componentProps = componentProps;
        state.dialogProps = dialogProps;
        state.component = componentName;
        state.open = true;
      },
    },
    actions: {
      showModal({ commit }, { componentName, componentProps, dialogProps }) {
        commit('SHOW_MODAL', { componentName, componentProps, dialogProps });
      },
      hideModal({ commit }) {
        commit('SET_OPEN', false);
      },
      toggleFullscreen({ commit, getters }) {
        commit('SET_FULLSCREEN', !getters.isFullscreen);
      },
    },
  });
};

export default modalModule;
